// Company Types
export const SET_CURRENT_COMPANY = "SET_CURRENT_COMPANY";
export const REMOVE_CURRENT_COMPANY = "REMOVE_CURRENT_COMPANY";
//  POst Job
export const POST_JOB_SUCCESS = "POST_JOB_SUCCESS";
export const POST_JOB_CLEAR = "POST_JOB_CLEAR";
export const POST_JOB_ERROR = "POST_JOB_ERROR";
// Job Form Details
export const FILL_FORM = "FILL_FORM";
// Filter Categories
export const FILTER_CATEG0RIES = "FILTER_CATEG0RIES";

// AUTH TYPES
// SIGN IN
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
// export const SIGNIN_ERROR = "SIGNIN_ERROR";
// SIGN OUT
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
// RESET PASSWORD
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_ERROR = "RESET_ERROR";
//SET AUTH LOADING
export const SET_AUTH_LOADING = "SET_AUTH_LOADING";


// EMAIL
export const SEND_EMAIL = "SEND_EMAIL";
export const EMPTY_EMAIL_DATA = "EMPTY_EMAIL_DATA";
export const NEWS_LETTER = "NEWS_LETTER";


// SETTING
export const SETTING_PAYMENT = "SETTING_PAYMENT";
